@if (initialized && dto) {
    @if (uiMode == 'side') {

        <bm-creditor-object-component-full
                [objectIdentifier]="objectIdentifier"
                [dto]="dto"
                [uiMode]="uiMode"
                (onNavigationItems)="handleNavigationItems($event)"
        ></bm-creditor-object-component-full>
    } @else {

        <bm-creditor-object-component-side
                [objectIdentifier]="objectIdentifier"
                [dto]="dto"
                [uiMode]="uiMode"
                (onNavigationItems)="handleNavigationItems($event)"
        ></bm-creditor-object-component-side>
    }
}
